import { IContactAddress } from '@trii/types/dist/Contacts';
import { IBusiness, IContact } from '@trii/types/dist/Contacts/contacts';
import { styled } from '@mui/system';
import { Box, Avatar, IconButton, Tooltip } from '@mui/material';
import {Star, StarBorder } from '@mui/icons-material';
import useImage from '../../../../../../../hooks/useImage';

type Props = {
  item: IContactAddress;
  owner?: IBusiness | IContact;
};

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.dropdownMenu,
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.text.primary,
  width: '50%',
  paddingBottom: '3px',
  minHeight: '50px',
  position: 'relative',
}));

const LeftSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
  overflow: 'hidden',
  maxWidth: '80%',
}));

const RightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const ContactDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: theme.spacing(0.5),
  overflow: 'hidden',
  flexFlow: 'nowrap',
  flexWrap: 'wrap',
  marginTop: '-5px',
}));

const AvatarWrapper = styled(Avatar)(({}) => ({
  width: 32,
  height: 32,
  cursor: 'pointer',
}));

const EllipsisText = styled(Box)(({}) => ({
  fontSize: 14,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

const NoteText = styled(EllipsisText)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  position: 'absolute',
  bottom: 0,
  maxWidth: '70%',
}));

const PhoneText = styled(EllipsisText)(({}) => ({
  fontSize: 14,
  fontWeight: 500,
}));

const ProfileNameText = styled(EllipsisText)(({}) => ({
  fontSize: 14,
  fontWeight: 500,
}));

const ContactMethodItem = ({ item }: Props) => {
  const avatarUrlWithoutAccess = item.profileUrl;

  const {imageUrl} = useImage({
    initialImageUrl: avatarUrlWithoutAccess,
  });

  return (
    <>
      <StyledBox>
        <LeftSection>
          <ContactDetails>
            <Tooltip title={item.address || ''} arrow>
              <PhoneText>{item.address}</PhoneText>
            </Tooltip>
            <Tooltip title={item.profileName || ''} arrow>
              <ProfileNameText
                sx={{
                  marginTop: '-10px',
                  marginLeft: '5px',
                  fontSize: '10px',
                }}
              >
                {item.profileName}
              </ProfileNameText>
            </Tooltip>
            <Tooltip title={item.note || ''} arrow>
              <NoteText>{item.note}</NoteText>
            </Tooltip>
          </ContactDetails>
        </LeftSection>
        <RightSection>
          {avatarUrlWithoutAccess !== '' && (
            <AvatarWrapper
              src={imageUrl}
              alt={item.profileName}
              style={{ cursor: 'pointer' }}
            >
              {item?.profileName?.charAt(0).toUpperCase()}
            </AvatarWrapper>
          )}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <IconButton
              size="small"
              sx={{ marginTop: '-5px', padding: 0 }}
            >
              {item.isFavorite ? (
                <Star
                  sx={{
                    color: '#fcac34',
                  }}
                />
              ) : (
                <StarBorder
                  sx={{
                    color: '#fcac34',
                  }}
                />
              )}
            </IconButton>
          </Box>
        </RightSection>
      </StyledBox>
    </>
  );
};

export default ContactMethodItem;
